export default __webpack_public_path__ + "static/media/1.2.ee4f6e8f.mp4";